import { IconButton, Tooltip } from '@mui/material'
import { LinkOff } from '@mui/icons-material'

interface UnlinkPageButtonProps {
  disabled?: boolean
  tooltip?: string
  disabledTooltip?: string
  onClick: () => void
}

/**
 * Só o gatilho do desvínculo. Em linha de tabela, use este botão e deixe o fluxo
 * (`UnlinkPageWithBadge` controlado) fora da tabela: os modais são portais e, renderizados
 * dentro da linha, seus cliques sobem pela árvore do React até o `onClick` do `TableRow`.
 */
const UnlinkPageButton = ({
  disabled,
  tooltip = 'Desvincular keeper',
  disabledTooltip,
  onClick,
}: UnlinkPageButtonProps) => (
  <Tooltip
    title={(disabled && disabledTooltip) || tooltip}
    placement='top'
    arrow
    data-testid='unlink-page-tooltip-test-id'
  >
    <span>
      <IconButton
        onClick={(event) => {
          event.stopPropagation()
          onClick()
        }}
        disabled={disabled}
        style={{ padding: 0, color: disabled ? '#5c5c5c' : '#d32f2f', cursor: 'pointer' }}
        data-testid='unlink-page-button-test'
      >
        <LinkOff style={{ fontSize: 20 }} />
      </IconButton>
    </span>
  </Tooltip>
)

export default UnlinkPageButton
